import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import { formatMoney } from '../../utils/formatMoney';
import { withRouter } from 'react-router';
import moment from 'moment';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedAdminDisbursements(props) {

  const { token, userId } = props;

  const [loading, setLoading] = useState(true);
  const [disbursements, setDisbursements] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);

    const paymentsProm = await fetch(`${apiUrl}/products/get/disbursements/admin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const paymentsResp = await paymentsProm.json();

    if (paymentsResp.success) {
      const { disbursements } = paymentsResp;
      setDisbursements(disbursements);
    }

    setLoading(false);
  };

  if (loading) {
    return (
      <div className="admin-disbursements-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }

  return (
    <div className="admin-disbursements-component">
      <Container>
        <Row>
          <Col>
            <h1>Desembolsos</h1>

            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Usuario</th>
                  <th>Monto</th>
                  <th>Estado</th>
                  <th>Fecha de solicitud</th>
                  <th>Fecha de desembolso</th>
                </tr>
              </thead>
              <tbody>
                {
                  disbursements.map((item, index) =>
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>{item.userEmail}</td>
                      <td>${formatMoney(item.amount)}</td>
                      <td>{item.status === 'REQUESTED' ? 'Solicitado' : 'Recibido'}</td>
                      <td>{moment(item.dateRequested).format('YYYY-MM-DD')}</td>
                      <td>
                        {
                          item.datePayed ?
                          moment(item.datePayed).format('YYYY-MM-DD') :
                          '-'
                        }
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>

    </div>
  );
}

const AdminDisbursements = connect(select)(ConnectedAdminDisbursements);

export default withRouter(AdminDisbursements);
